// Use only for explicitly selected GETs. Account data and transaction requests stay uncached.
export default class RequestCache<T> {
    private entries = new Map<string, { promise: Promise<T>; expiresAt: number }>();

    constructor(private readonly maxAge = 0) {}

    get(key: string, load: () => Promise<T>): Promise<T> {
        const existing = this.entries.get(key);
        if (existing && existing.expiresAt > Date.now()) return existing.promise;

        const entry = { promise: undefined as Promise<T>, expiresAt: Infinity };
        entry.promise = Promise.resolve()
            .then(load)
            .then(value => {
                entry.expiresAt = Date.now() + this.maxAge;
                if (!this.maxAge && this.entries.get(key) === entry) this.entries.delete(key);
                return value;
            })
            .catch(error => {
                if (this.entries.get(key) === entry) this.entries.delete(key);
                throw error;
            });
        this.entries.set(key, entry);
        return entry.promise;
    }

    clear() {
        this.entries.clear();
    }
}
